import React from 'react';
import { Box, Typography, Paper, Link, Divider, Avatar, IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import SvgIcon from '@mui/material/SvgIcon';

// TikTok SVG as MUI SvgIcon
function TikTokIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M21.5 7.5c-1.7 0-3-1.3-3-3V3h-3.2c-.4 0-.8.3-.8.8v11.7c0 1.3-1 2.5-2.3 2.5s-2.3-1.1-2.3-2.5c0-1.3 1-2.5 2.3-2.5.4 0 .8.1 1.1.3.3.2.7.1.9-.2.2-.3.1-.7-.2-.9-.6-.4-1.2-.6-1.8-.6-2.1 0-3.8 1.8-3.8 4s1.7 4 3.8 4 3.8-1.8 3.8-4V9.7c1 .6 2.1.9 3.2.9.4 0 .8-.3.8-.8v-2c0-.4-.3-.8-.8-.8z" />
    </SvgIcon>
  );
}

export default function Support() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f6f2',
      }}
    >
      <Paper
        elevation={4}
        sx={{
          minWidth: 340,
          maxWidth: 420,
          width: '100%',
          p: 4,
          borderRadius: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          background: '#fffdfa',
          boxShadow: '0 4px 24px 0 rgba(255,112,67,0.08)',
          border: '1.5px solid #ffe0b2',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: '#333', letterSpacing: 0.5 }}>
          Get in Touch With Us
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
          <EmailIcon sx={{ color: '#FF7043', mr: 1, fontSize: 24 }} />
          <Link
            href="mailto:support@ascendyantra.com"
            underline="hover"
            sx={{ fontSize: 17, color: '#333', fontWeight: 500, '&:hover': { color: '#FF7043' } }}
          >
            support@ascendyantra.com
          </Link>
        </Box>

        {/* Ascend Yantra Section */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0, mt: 1 }}>
          <Avatar
            src={require('../assets/yantras-logo.png')}
            alt="Yantra Logo"
            sx={{ width: 40, height: 40, mr: 1, bgcolor: 'transparent' }}
            variant="square"
          />
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 19, color: '#333' }}>
            Ascend Yantra
          </Typography>
        </Box>
        <Typography sx={{ color: '#FF7043', fontSize: 14, fontStyle: 'italic', mb: 1.5, ml: '48px', fontWeight: 500 }}>
          Breathe. Meditate. Ascend.
        </Typography>

        {/* Social Icons */}
        <Box sx={{ display: 'flex', gap: 2.5, mb: 1.5, ml: '2px', mt: 1.5}}>
          <IconButton
            component="a"
            href="https://www.youtube.com/@AscendYantra"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            sx={{ color: '#FF0000', bgcolor: '#fff3e0', borderRadius: 2, p: 1.2, transition: '0.2s', '&:hover': { bgcolor: '#FF7043', color: '#fff' } }}
          >
            <YouTubeIcon fontSize="large" />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.instagram.com/ascendyantra?igsh=OW00MXd1aWg4dmJj"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            sx={{ color: '#C13584', bgcolor: '#fff3e0', borderRadius: 2, p: 1.2, transition: '0.2s', '&:hover': { bgcolor: '#FF7043', color: '#fff' } }}
          >
            <InstagramIcon fontSize="large" />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.facebook.com/profile.php?id=61577776784576"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            sx={{ color: '#1877F3', bgcolor: '#fff3e0', borderRadius: 2, p: 1.2, transition: '0.2s', '&:hover': { bgcolor: '#FF7043', color: '#fff' } }}
          >
            <FacebookIcon fontSize="large" />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.tiktok.com/@ascendyantra?lang=en"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
            sx={{ color: '#000', bgcolor: '#fff3e0', borderRadius: 2, p: 1.2, transition: '0.2s', '&:hover': { bgcolor: '#FF7043', color: '#fff' } }}
          >
            <TikTokIcon fontSize="large" />
          </IconButton>
        </Box>

        <Divider sx={{ width: '100%', my: 2 }} />
        <Box
          sx={{
            width: '100%',
            textAlign: 'left',
            background: '#fff8f1',
            borderRadius: 2,
            p: 2,
            border: '1px solid #ffe0b2',
            mt: 1,
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
            © 2025 FlowXperience Inc. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
            <Link href="/terms-and-conditions" underline="hover" sx={{ fontSize: 15, fontWeight: 500, color: '#333', '&:hover': { textDecoration: 'underline', color: '#F4511E' } }} target="_blank" rel="noopener noreferrer">
              Terms and Conditions
            </Link>
            <Link href="/privacy-policy" underline="hover" sx={{ fontSize: 15, fontWeight: 500, color: '#333', '&:hover': { textDecoration: 'underline', color: '#F4511E' } }} target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </Link>
            <Link href="/about-us" underline="hover" sx={{ fontSize: 15, fontWeight: 500, color: '#333', '&:hover': { textDecoration: 'underline', color: '#F4511E' } }} target="_blank" rel="noopener noreferrer">
              About Us
            </Link>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
} 